import { Directive, ComponentRef, Type, ViewContainerRef, Input } from "@angular/core";
import { WebcontentComponent } from "./web-content/web-content.component";
import { GenericWidgetComponent } from "./generic-widget/generic-widget.component";
import { WidgetsEntity } from "src/app/models/widget-entity.model";
import { FormComponent } from "./forms/forms.component";
import { MenuComponent } from "./menu/menu.component";
import { ComponentLoaderService } from "src/app/miscellaneous/component-loader.service";
import { SmartTableComponent } from "./smart-table/smart-table.component";
import { AssetPublisherComponent } from "./asset-publisher/asset-publisher.component";
import { TabsComponent } from "./tabs/tabs.component";
import { TreeMenuComponent } from "./tree-menu/tree-menu.component";
import { DynamicContentComponent } from "./dynamic-content/dynamic-content.component";

@Directive({
  selector: "[appLoader]",
})
export class LoaderDirective {
  //@ViewChild('appLoader', { read: ViewContainerRef }) vcr: ViewContainerRef;
  @Input() appLoader!: string | null;
  @Input() props!: WidgetsEntity | null;

  public cRef: Array<ComponentRef<any>> = [];

  constructor(
    private vcr: ViewContainerRef,
    private cls: ComponentLoaderService
  ) {}

  ngOnInit(): void {
    const compRef: ComponentRef<any> = this.cls.loadComponent(
      this.vcr,
      this.componentTypeResolver(this.appLoader),
      this.props
    );
    this.cRef.push(compRef);
  }

  componentTypeResolver(type: string | null): Type<any> {
    switch (type) {
      case WebcontentComponent.compName:
        return WebcontentComponent;
      case FormComponent.compName:
        return FormComponent;
      case MenuComponent.compName:
        return MenuComponent;
      case SmartTableComponent.compName:
        return SmartTableComponent;
      case AssetPublisherComponent.compName:
        return AssetPublisherComponent;
      case TabsComponent.compName:
        return TabsComponent;
      case TreeMenuComponent.compName:
        return TreeMenuComponent;
      case DynamicContentComponent.compName:
        return DynamicContentComponent;

      default: {
        return GenericWidgetComponent;
      }
    }
  }

  ngOnDestroy() {
    this.cRef.forEach((e) => e.destroy());
  }
}
